import React, {useEffect} from 'react'
import Grid from '@mui/material/Grid'
import PropTypes from 'prop-types'
import moment from 'moment'
import {Typography, Spacing} from '../../../assets/styles'
import {makeStyles} from '@mui/styles'
import SingleDeskHourScheduleInput from './SingleDeskHourScheduleInput'
import SingleDeskHourExceptionInput from './SingleDeskHourExceptionInput'
import ManyDeskHourExceptionInput from './ManyDeskHourExceptionInput'

function EditDeskHours(props) {
  const classes = useStyles()

  // filter out past exceptions
  const exceptionsToRender = props.exceptions.filter(e => moment(e.date).isAfter(moment().subtract(1, 'day')))

  const handleChangeSchedule = updatedScheduleDay => {
    let nextSchedule = [...props.schedule]
    nextSchedule[updatedScheduleDay.dayOfWeek] = updatedScheduleDay
    props.onChange({
      schedule: nextSchedule,
      exceptions: props.exceptions,
    })
  }

  const handleChangeException = updatedExceptions => {
    props.onChange({
      schedule: props.schedule,
      exceptions: updatedExceptions,
    })
  }

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <h3 className={classes.sectionHeader}>Regular schedule</h3>
      </Grid>
      <Grid item xs={12}>
        {props.schedule.map((v, index) => (
          <SingleDeskHourScheduleInput error={props.scheduleErrors} key={index} value={v} onChange={handleChangeSchedule} />
        ))}
      </Grid>
      <Grid item xs={12}>
        <h3 className={classes.sectionHeader}>
          Schedule Changes <span>(will override regular schedule)</span>
        </h3>
      </Grid>
      <Grid item xs={12}>
        <ManyDeskHourExceptionInput value={exceptionsToRender} onChange={handleChangeException} />
      </Grid>
    </Grid>
  )
}

const useStyles = makeStyles(theme => ({
  sectionHeader: {
    ...Typography.H4HeaderBlack,
    textTransform: 'uppercase',
    marginTop: Spacing.spaceMedium,

    '& span': {
      textTransform: 'none',
      fontWeight: 'normal',
      marginLeft: '8px',
      ...Typography.BodyHeader,
    },
  },
}))

EditDeskHours.propTypes = {
  schedule: PropTypes.arrayOf(PropTypes.shape(SingleDeskHourScheduleInput.propTypes.value)), // array of scheduled desk hours
  exceptions: PropTypes.arrayOf(PropTypes.shape(SingleDeskHourExceptionInput.propTypes.value)), // array of exceptions to desk hours
  scheduleErrors: PropTypes.bool,
  exceptionsErrors: PropTypes.bool,
  onChange: PropTypes.func.isRequired, // returns updated desk hours object
}

export default EditDeskHours
